import React, { ReactElement } from 'react';

import { msg } from '@philips-emr/tws-core/lib/services/message-service';

export interface ModalTitleProps {
  children: string;
}

function ModalTitle(props: ModalTitleProps): ReactElement | null {
  const { children } = props;

  if (!children) {
    return null;
  }

  return <div className="c-modal__title u-hide@empty">{msg(children)}</div>;
}

export default ModalTitle;
